export const ASSET_PREFIX = '/homepage'
